const currentEnvironment = {
  development: {
    url: 'https://apiconnect.angelone.in/rest/',
    forumUrl: 'https://smartapi.angelbroking.com/smartapi/forum',
    // url: 'https://openapisuat.angelbroking.com/client-service/rest/',
  },
  staging: {
    url: 'https://apiconnect.angelone.in/rest/',
    forumUrl: 'https://smartapi.angelbroking.com/smartapi/forum',
    // url: 'https://openapisuat.angelbroking.com/client-service/rest/',
  },
  production: {
    url: 'https://apiconnect.angelone.in/rest/',
    forumUrl: 'https://smartapi.angelbroking.com/smartapi/forum',
  },
};

const env = process.env.REACT_APP_API_URL;
console.log('Environment selected:', env);

export default process.env.REACT_APP_API_URL === 'development'
  ? currentEnvironment.development
  : process.env.REACT_APP_API_URL === 'staging'
  ? currentEnvironment.staging
  : process.env.REACT_APP_API_URL === 'production'
  ? currentEnvironment.production
  : currentEnvironment.development;
